import '../styles/style.scss';

import React from 'react';

export default function App({ Component, pageProps, err }) {
  return <Component {...pageProps} err={err} />;
}
